import dynamic from 'next/dynamic';

export const JsonFormReviewModal = dynamic(
  () =>
    import('./json-form-review/json-form-review-modal').then(
      (mod) => mod.JsonFormReviewModal
    ),
  { ssr: false, loading: () => null }
);
